// NG名称定義照会・更新画面の一覧表のラベル
export const LABELS = {
  TITLE: "NG名称定義",
  NGNAME: "NG名称",
  UPLOAD_CONFIIM:
    "アップロード前件数：{0}件\r\nアップロード後件数：{1}件\r\n新規：{2}件\n/\n削除：{4}件",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENTION: ".csv",
  SUCCSESS: "success",
} as const;